<template>
  <el-dialog
    :title="'选择物料出库信息'"
    :visible.sync="visible"
    append-to-body
    v-dialogDrag
    width="900px"
    :close-on-click-modal="false"
  >
    <template>
      <div>
        <el-table
          :data="data"
          ref="table"
          highlight-current-row
          @selection-change="selectionChange"
          @current-change="handleCurrentChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            label="仓库编号"
            prop="WarehouseId"
            width="180"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="仓库名称" show-overflow-tooltip
            ><template slot-scope="{ row }">
              {{ row.WarehouseName | gang }}
            </template></el-table-column
          >
          <el-table-column label="物料名称" show-overflow-tooltip
            ><template slot-scope="{ row }">
              {{ row.MaterialName | gang }}
            </template>
          </el-table-column>
          <el-table-column label="重量" prop="Weight" show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            label="单位"
            prop="Unit"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="入场编号" show-overflow-tooltip
            ><template slot-scope="{ row }">
              {{ row.Source }}
            </template></el-table-column
          >
          <!-- <el-table-column
            label="重量"
            prop="CarId"
            show-overflow-tooltip
            hidden
          >
          </el-table-column> -->
        </el-table>

        <el-pagination
          ref="breadCrumb"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[10, 20, 50, 100]"
          @size-change="getTableData(1)"
          @current-change="getTableData()"
          :current-page.sync="pageIndex"
          :page-size.sync="pageSize"
          :total="pageTotal"
        ></el-pagination>
      </div>
    </template>
    <span slot="footer">
      <el-button type="primary" @click="save" :loading="loading"
        >确认出库</el-button
      >
      <el-button type="canale" @click="visible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>
    
<script>
import UploadPhoto from "@/components/UploadPhoto.vue";
export default {
  props: ["item"],
  components: {
    UploadPhoto,
  },
  data() {
    return {
      visible: false,
      loading: false,
      isable: true,
      isEdit: false,
      form: {},
      pageIndex: 1,
      pageSize: 10,
      pageTotal: 0,
      WarehouseId: "",
      InventoryId: "",
      selectdata: [],
      EntyId: [],
      data: [],
    };
  },
  computed: {},
  watch: {
    item: {
      handler: function (v) {
        this.visible = true;
        this.WarehouseId = v.WarehouseId;
        this.InventoryId = v.InventoryId;
        this.$get("MaterialInventory/GetOutMaterialList", {
          WarehouseId: v.WarehouseId,
          InventoryId: v.InventoryId,
          PageNumber: this.pageIndex,
          PageSize: this.pageSize,
        }).then((r) => {
          let list = r.Result;
          let pageTotal = r.Rows;
          if (list.length > 0) {
            let row = list[0];
            this.$refs.table.setCurrentRow(row);
          }
          this.data = list;
          this.pageTotal = pageTotal;
        });
      },
    },
  },
  methods: {
    init(form) {
      this.form = { ...form };
      if (this.$refs["form"]) {
        this.$refs["form"].resetFields();
      }
    },
    save() {
      let params = {};
      params.selectdata = this.selectdata;

      if (params.selectdata.length == 0) {
        this.$message.error("请选择出库信息");
        return;
      }

      this.loading = true;
      this.$post("MaterialInventory/MaterialExit", params).then((r) => {
        this.$message.success("出库成功");
        this.visible = false;
        this.$emit("success");
      });
      this.loading = false;
    },
    selectionChange(selection) {
      this.selectdata = selection;
    },
    handleCurrentChange(row) {
      this.$emit("currentrow", row);
    },
    getTableData(pageIndex) {
      // var parm = { ...this.filter };
      // if (parm.selectedDate) {
      //   parm.selectedDate = JSON.stringify(parm.selectedDate);
      // }

      if (pageIndex) {
        this.pageIndex = pageIndex;
      }
      this.$get("MaterialInventory/GetOutMaterialList", {
        WarehouseId: this.WarehouseId,
        InventoryId: this.InventoryId,
        PageNumber: this.pageIndex,
        PageSize: this.pageSize,
      }).then((r) => {
        let list = r.Result;
        let pageTotal = r.Rows;
        if (list.length > 0) {
          let row = list[0];
          this.$refs.table.setCurrentRow(row);
        }
        this.data = list;
        this.pageTotal = pageTotal;
      });
    },
  },
};
</script>    
<style lang="scss" scoped>
@import "@/themes/common";

h4 {
  margin-top: 10px;
  @include font_color("text-color2");
}
</style>